function Option(prop) {
    const { optionProps,
        highlighted,
        selected,
        option,
        cls,
        renderOption,
        disabled, } = prop
    const props = {
        ...optionProps,
        value: encodeURIComponent(option.value),
        disabled,
    }

    return (
        <li className='select-search-row' data-index={option.index}>
            <div className='select-li-row'>
                <img className='li-row-icon' height="45" width="45" src={option.url} alt='' />
                <button type='button' className='select-search-option' {...props}>
                    {option.name}
                </button>
            </div>
        </li>
    )
}

export default Option